import { Button, Card, DatePicker, Dropdown, Input, Menu, Modal, PageHeader, Space, Table } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { getReservations, roomsDelete } from '../../appRedux/actions/Booking';
import { Link } from "react-router-dom";
import PageContentWrapper from '../../components/PageContentWrapper';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';

const ReservationsPage = () => {
  const [dates, setDates] = useState([moment().startOf('year').toISOString(), moment().endOf('year').toISOString()]);
  const [loading, setLoading] = useState(true);
  const [reservations, setReservations] = useState([]);
  const [totalReservations, setTotalReservations] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [query, setQuery] = useState("");

  useEffect(() => {
    fetchData()
  }, [dates, currentPage, pageSize, query]);

  function fetchData() {
    setLoading(true)
    getReservations({
      start_date: dates[0],
      end_date: dates[1],
      current_page: currentPage,
      page_size: pageSize,
      name: query,
    }).then((data) => {
      setReservations(data.data)
      setTotalReservations(data.meta.total)
      setLoading(false)
    })
  }

  const columns = [
    {
      title: "Check In",
      dataIndex: "start",
      key: "start",
      render: (start) => <>{moment(start).format("dddd, D MMMM YYYY")}</>
    },
    {
      title: "Check Out",
      dataIndex: "end",
      key: "end",
      render: (end) => <>{moment(end).format("dddd, D MMMM YYYY")}</>
    },
    {
      title: "Nomor Kasur",
      dataIndex: "room_number",
      key: "room_number",
      render: (room_number) => <>{room_number}</>
    },
    {
      title: "Peserta",
      dataIndex: "participant_name",
      key: "participant_name",
      render: (participant_name, field) => <>
        {field.participant_id ? (
          <Link to={"/participant/" + field.participant_id}>{participant_name}</Link>
        ) : (
          <span>{participant_name}</span>
        )}
      </>
    },
    {
      title: "Training",
      dataIndex: "training_name",
      key: "training_name",
      render: (training_name, field) => <>
        <Link to={"/training/" + field.training_id}>{training_name}</Link>
      </>
    },
    {
      width: 10,
      render: (item) => <Dropdown
        overlay={
          <Menu>
            <Menu.Item
              key="0"
              icon={<DeleteOutlined />}
              danger
              onClick={() => {
                Modal.confirm({
                  title: "Konfirmasi",
                  content: "Apakah anda yakin ingin menghapus reservasi ini ?",
                  onOk: () => {
                    roomsDelete(item.id).then(() => {
                      fetchData()
                    });
                  }
                })
              }}
            >
              Hapus
            </Menu.Item>
          </Menu>
        }
        placement="bottomRight"
        trigger={["click"]}
      >
        <i className="gx-icon-btn icon icon-ellipse-v" />
      </Dropdown>,
    },
  ];

  return <>
    <PageContentWrapper
      ghost={false}
      title="Reservasi Kamar Inap"
      extra={
        <Link to="/reservations/add">
          <Button icon={<PlusOutlined />} type="primary" style={{ margin: 0 }}>
            Tambah
          </Button>
        </Link>
      }
    >
      <Card bordered={false} style={{ borderRadius: 0 }}>
        <Space direction="vertical" style={{ width: "100%" }}>
          <Space wrap>
            <DatePicker.RangePicker
              format="D MMMM YYYY"
              onChange={(v) =>
                v
                  ? setDates(v.map((date) => date.toISOString()))
                  : setDates([null, null])
              }
              value={dates.map((date) => (date ? moment(date) : null))}
            />
            <Input
              style={{ margin: 0 }}
              placeholder="ketik pencarian"
              allowClear
              onChange={(e) => {
                setQuery(e.target.value)
              }}
            />
          </Space>
          <Table
            loading={loading}
            size="small"
            columns={columns}
            dataSource={reservations.map((reservation) => ({
              ...reservation,
              key: reservation.id,
            }))}
            pagination={{
              total: totalReservations,
              position: ["bottomCenter"],
              responsive: true,
              onChange: (page, pageSize) => {
                setCurrentPage(page);
                setPageSize(pageSize);
              },
              pageSize,
              current: currentPage,
              showSizeChanger: true,
              showTotal: (total, range) => {
                return `Menampilkan ${range[0]}-${range[1]} dari ${total} reservasi`;
              }
            }}
          />
        </Space>
      </Card>
    </PageContentWrapper>
  </>
};

export default ReservationsPage;